module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"movieSettingsTitle\" class=\"prop-header\"><span class=\"prop-label\">Movie Settings</span></div>\r\n<div class=\"prop-detail main-picture\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4 prop-sublabel\">Asset</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <select id=\"assetSelect\" name=\"asset\" >\r\n                <option value=\"\">None</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 form-group-flex\">\r\n            <input type=\"checkbox\" name=\"maintainAspectRatio\">\r\n            <label class=\"form-group-label\">Maintain aspect ratio</label>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 form-group-flex\">\r\n            <input type=\"checkbox\" name=\"autoPlay\" class=\"form-radio-group\">\r\n            <label class=\"form-group-label\">Autoplay</label>\r\n        </div>\r\n        <div class=\"col-md-6 nopadding form-group-flex\">\r\n            <input type=\"checkbox\" name=\"loop\" class=\"form-radio-group\"> \r\n            <label class=\"form-group-label\">Loop</label>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-1\" style=\"font-size: 24px;\">\r\n            <i class=\"fa pf-sound\"></i>\r\n        </div>\r\n        <div class=\"col-md-11\" style=\"height: 24px; padding-top: 9px;\">\r\n            <div id=\"volume\"></div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}